import { createRoute } from '@tanstack/react-router'
import { t } from 'i18next'

import { StaticRouteParameter } from 'config/routing'
import { Overview } from 'domains/MediaPlatforms/Spaces'
import { mediaPlatformRoute } from 'pages/NWPlatform/MediaPlatforms/MediaPlatform/Routing'
import { Structure } from 'pages/NWPlatform/MediaPlatforms/MediaPlatform/Spaces'

export const mediaPlatformSpacesRoute = createRoute({
  getParentRoute: () => mediaPlatformRoute,
  path: StaticRouteParameter.SPACES,
  loader: () => ({
    crumb: t('entity:publishing.space', { count: 2 }),
  }),
})

export const mediaPlatformSpacesLayoutRoute = createRoute({
  getParentRoute: () => mediaPlatformSpacesRoute,
  id: 'mediaPlatformSpacesLayout',
  component: Structure,
})

type MediaPlatformSpacesOverviewSearch = {
  query?: string
}

export const mediaPlatformSpacesOverviewRoute = createRoute({
  getParentRoute: () => mediaPlatformSpacesLayoutRoute,
  path: '/',
  component: Overview,
  validateSearch: (search: Record<string, unknown>): MediaPlatformSpacesOverviewSearch => ({
    ...(!!search.query && typeof search.query === 'string' && { query: search.query }),
  }),
})
